import { Dispatch, useReducer, useEffect, useRef, useCallback } from 'react'

export default function useVolatileReducer<TState, TAction>(
  reducer: (state: TState, action: TAction) => TState,
  initialState: TState
): [TState, Dispatch<TAction>] {
  const isExpired = useRef(false)
  const [state, dispatch] = useReducer(reducer, initialState)

  const dispatchWrapper = useCallback((incomingAction: TAction) => {
    if (!isExpired.current) {
      dispatch(incomingAction)
    }
  }, [])

  useEffect(() => {
    return () => {
      isExpired.current = true
    }
  }, [])

  return [state, dispatchWrapper]
}
